import React from 'react'

const WIDTHS = ['w-3/4', 'w-1/2', 'w-2/3', 'w-5/6', 'w-1/3', 'w-3/5'] as const

export interface TableSkeletonProps {
  columns: number
  rows?: number
  className?: string
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  columns,
  rows = 8,
  className,
}) => (
  <>
    {Array.from({ length: rows }).map((_, rowIdx) => (
      <tr key={rowIdx} className={`border-b border-gray-100 ${className ?? ''}`}>
        {Array.from({ length: columns }).map((_, colIdx) => (
          <td key={colIdx} className="px-3 py-3">
            <div
              className={`h-3 bg-gray-200 rounded animate-pulse ${WIDTHS[(rowIdx + colIdx) % WIDTHS.length]}`}
            />
          </td>
        ))}
      </tr>
    ))}
  </>
)
